
import { Component, Prop, Vue } from 'vue-property-decorator'
import TicketGygl from '@/views/Ticket/indexGygl.vue'

@Component({
  name: 'AllMyCreatedOrderLists',
  components: {
    TicketGygl
  }
})
export default class extends Vue {}
